import { render, staticRenderFns } from "./Flash.vue?vue&type=template&id=3541a4ab&scoped=true&"
import script from "./Flash.vue?vue&type=script&lang=js&"
export * from "./Flash.vue?vue&type=script&lang=js&"
import style0 from "./Flash.vue?vue&type=style&index=0&id=3541a4ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3541a4ab",
  null
  
)

export default component.exports